import api from "./api";
import { PaginatedResponse } from "@/types/borrower";

export interface Broker {
  id: number;
  email: string;
  first_name?: string;
  last_name?: string;
  name?: string;
  company_name: string;
  is_active: boolean;
  is_steddyuser: boolean;
  created_at: string;
  updated_at: string;
  created_by?: number;
}

export const brokerService = {
  list: async (
    params: { page?: number; search?: string; is_steddyuser?: boolean } = {}
  ): Promise<PaginatedResponse<Broker>> => {
    const response = await api.get<PaginatedResponse<Broker>>("/accounts/brokers/", { params });
    return response.data;
  },
};
